import { getMessagesByLanguage, localeAlternatives } from 'shared-locales';

import type { Block, Locales } from 'shared-types';

interface Params {
  blockType: Block['type'];
  courseLanguage: string;
  defaultData: Block['data'];
}

const addInitialDataToBlockDefaultData = ({
  blockType,
  courseLanguage,
  defaultData
}: Params) => {
  const updatedDefaultData = JSON.parse(JSON.stringify(defaultData));

  if (blockType === 'likert') {
    const messagesLocale: Locales =
      localeAlternatives[courseLanguage] || 'en-GB';

    const messages = getMessagesByLanguage(messagesLocale);

    updatedDefaultData.locales[courseLanguage].translatable = {
      ...updatedDefaultData.locales[courseLanguage].translatable,
      option_1: messages.editorBlockLikertOptionDisagree,
      option_2: messages.editorBlockLikertOptionSomewhatDisagree,
      option_3: messages.editorBlockLikertOptionNeither,
      option_4: messages.editorBlockLikertOptionSomewhatAgree,
      option_5: messages.editorBlockLikertOptionAgree
    };
  }

  return updatedDefaultData;
};

export default addInitialDataToBlockDefaultData;
